import * as React from "react";
import PropTypes from "prop-types";
import Pagination from "@mui/material/Pagination";

function TablePaginationActions(props) {
  const { count, page, rowsPerPage, onPageChange } = props;

  const totalPages = Math.ceil(count / rowsPerPage);

  const handleChangePage = (event, newPage) => {
    onPageChange(event, newPage - 1);
  };

  return (
    <div className="flex justify-center mt-5">
      <Pagination
        count={totalPages}
        page={page + 1}
        onChange={handleChangePage}
        showFirstButton={false}
        showLastButton={false}
        color="primary"
        size="medium"
        sx={{
          "& .MuiPagination-ul": {
            display: "flex",
            alignItems: "center",
            flexWrap: "nowrap",
          },
          "& .MuiPaginationItem-root": {
            minWidth: 36,
            height: 36,
            borderRadius: "10%",
            fontSize: "0.875rem",
            fontWeight: 500,
            border: "1px solid #ff6100",
            margin: "0 4px",
            padding: "6px 15px",
            transition: "all 0.2s ease",
            color: "#333",
          },
          "& .MuiPaginationItem-page.Mui-selected": {
            backgroundColor: "#ff6100",
            color: "white",
            borderColor: "#ff6100",
          },
          "& .MuiPaginationItem-page:hover": {
            backgroundColor: "#f5f5f5",
            borderColor: "#ff6100",
          },
          "& .MuiPaginationItem-ellipsis": {
            opacity: 0.6,
            color: "#333",
          },
          "& .MuiPaginationItem-first, & .MuiPaginationItem-last": {
            display: "none",
          },
        }}
      />
    </div>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

export default TablePaginationActions;